// Third-party libraries
import clsx from 'clsx';

// Hooks
import { useTransformStringOnOffset } from '@/utils/hooks/format/useTransformString';

import { hashtagMentionsRegex } from '@/lib/regex';
// Utils/Helpers
import {
    getOffsets,
    sanitizeFacebook,
    sanitizeLinkedin
} from '@/lib/scheduler/getOffsetFromCaption';
// Constants/Libs
import { FACEBOOK, LINKEDIN } from '@/lib/socialProfile';

export const CaptionPreview = ({
    caption,
    network,
    displayAsTitle = false,
    mentions,
    className = '',
    as: Component = 'a'
}) => {
    const { formatTextWithComponent, OffsetReplace } = useTransformStringOnOffset();

    const offset = getOffsets(caption, hashtagMentionsRegex, mentions, network);
    let formattedCaption = formatTextWithComponent(caption, offset);

    switch (network) {
        case FACEBOOK:
            formattedCaption = sanitizeFacebook(formattedCaption);
            break;
        case LINKEDIN:
            formattedCaption = sanitizeLinkedin(formattedCaption);
            break;
        default:
            break;
    }

    return (
        <div
            className={clsx(
                `scrollbar max-h-56 overflow-auto break-words leading-5 tracking-tight`,
                displayAsTitle
                    ? 'text-md dark:text-icoDarkMode-white font-GBold text-icoBlack'
                    : 'font-GMedium text-sm text-icoGray-500 dark:text-icoDarkMode-wolf',
                className
            )}>
            <OffsetReplace
                text={formattedCaption}
                components={{
                    br: <br />,
                    ...Object.assign(
                        {},
                        offset?.map((el, id) => (
                            <Component
                                key={id}
                                href={el.link}
                                className="text-icoBlue"
                                target="_blank"
                                rel="noopener noreferrer"
                            />
                        ))
                    )
                }}
            />
        </div>
    );
};
